<template>
  <div class="register-form">
    <div class="mdl-card mdl-shadow--2dp" v-if="state=='resent' || state=='done'">
      <div class="mdl-card__title">
        <h2 class="mdl-card__title-text">{{ i18n()[state].title }}</h2>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand loading">
        <p>{{ i18n()[state].text({email}) }}</p>
      </div>
    </div>

    <div class="mdl-card mdl-shadow--2dp" v-if="state != 'resent' && state != 'done'">
      <div class="mdl-card__title mdl-card-colo">
        <h2 class="mdl-card__title-text">{{ i18n().title }}</h2>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand">

        <div class="error" v-if="error">
          <span v-if="error">{{ i18n().errors[error] || error }}</span>
          <a href="#" @click="resend" v-if="error == 'registrationNotConfirmed'">{{ i18n().resendButton }}</a>
        </div>

        <form v-on:submit="register" v-bind:class="{ blurred: state == 'working' }">

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input class="mdl-textfield__input" type="text" id="firstName" v-model="firstName"
                   v-bind:required="required" ref="firstName">
            <label class="mdl-textfield__label" for="firstName">{{ i18n().firstName }}</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input class="mdl-textfield__input" type="text" id="lastName" v-model="lastName"
                   v-bind:required="required" ref="lastName">
            <label class="mdl-textfield__label" for="lastName">{{ i18n().lastName }}</label>
          </div>

          <PhoneInput class="phoneNumber"
                      :value.sync="phoneNumber" :required="required" :invalid="phoneNumberInvalid"
                      :label="i18n().phoneNumber"></PhoneInput>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input class="mdl-textfield__input" type="email" id="email" v-model="email"
                   v-bind:required="required" ref="email">
            <label class="mdl-textfield__label" for="email">{{ i18n().email }}</label>
          </div>

          <div class="error" v-if="passwordTooSimple">
            <span>{{ i18n().passwordTooSimple }}</span>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input class="mdl-textfield__input" type="password" id="password" v-model="password"
                   v-bind:required="required" ref="password">
            <label class="mdl-textfield__label" for="password">{{ i18n().password }}</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input class="mdl-textfield__input" type="password" id="password2" v-model="password2"
                   v-bind:required="required" ref="password2">
            <label class="mdl-textfield__label" for="password2">{{ i18n().retypePassword }}</label>
            <span v-if="notMatch" class="mdl-textfield__error">{{ i18n().notMatch }}</span>
          </div>

          <vue-recaptcha :sitekey="recaptchaSiteKey" @verify="verified" ref="recaptcha"></vue-recaptcha>

          <button class="mdl-button mdl-js-button mdl-button--raised" type="submit">
            {{ i18n().submit }}
          </button>

        </form>

        <div class="working" v-if="state == 'working'">
          <div class="mdl-spinner mdl-js-spinner is-active"></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import i18n from "i18n"
  import api from "api"
  import PhoneInput from "../utils/PhoneInput.vue"

  function checkPassword(pass) {
    let digits = /\d/.test(pass)
    let lower = /[a-z]/.test(pass)
    let upper = /[A-Z]/.test(pass)
    return pass.length>=8 && digits && lower && upper
  }

  export default {
    name: 'register-form',
    metaInfo: {
      title: i18n().emailPassword.registerForm.title
    },
    components: {
      PhoneInput
    },
    data () {
      return {
        state: "ready",
        error: null,
        email: "",
        password: "",
        password2: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        phoneNumberInvalid: false,
        requiredFields: ['firstName', 'lastName', 'phoneNumber', 'email', 'password', 'password2'].reverse(),
        required: false,
        notMatch: false,
        captchaResponse: false,
        recaptchaSiteKey: GRECAPTCHA_SITE_KEY,
        recaptchaKey: null,
        passwordTooSimple: false
      }
    },
    computed: {
    },
    methods: {
      i18n() { return i18n().emailPassword.registerForm },
      verified(response) {
        console.log("VERIFIED", response)
        this.recaptchaKey = response
      },
      register(e) {
        e.preventDefault()

        let anyEmpty = false
        for(let fieldName of this.requiredFields) if(this[fieldName].trim() == '') {
          anyEmpty = true
          if(fieldName == "phoneNumber") {
            this.phoneNumberInvalid = true
            continue
          }
          let el = this.$refs[fieldName]
          el.parentElement.setAttribute('class', el.parentElement.getAttribute('class')+' is-invalid')
          el.focus()
        }
        if(anyEmpty) {
          this.required = true
          return;
        }

        let sep = this.phoneNumber.indexOf(' ')
        console.log("PN",this.phoneNumber, sep)
        if( sep == -1
            || this.phoneNumber.slice(0, sep).trim().length == 0
            || this.phoneNumber.slice(sep+1).trim().length < 3
            || !this.phoneNumber.match(/^[0-9 #+-]+$/)) {
          console.log("PN INVALID",
            this.phoneNumber.slice(0, sep).trim().length == 0,
            this.phoneNumber.slice(sep+1).trim().length < 3,
            !this.phoneNumber.match(/^[0-9 #+-]+$/)
          )
          this.phoneNumberInvalid = false
          this.phoneNumberInvalid = true
          this.required = true
          return;
        }

        if(!this.recaptchaKey) {
          this.error = 'noRecaptcha'
          return;
        }

        this.passwordTooSimple = !checkPassword(this.password)
        console.log("CHECK PASSWORD", this.passwordTooSimple, this.password)
        if(this.passwordTooSimple) return

        if(this.password != this.password2) {
          this.notMatch = true
          this.$refs.password2.parentElement.setAttribute('class',
            this.$refs.password2.parentElement.getAttribute('class')+' is-invalid')
          this.$refs.password2.focus()
          return;
        }

        this.state = "working"

        let userData = {
          firstName : this.firstName,
          lastName : this.lastName,
          phoneNumber : this.phoneNumber
        }

        logger.addPassword(this.password)
        api.request(["emailPassword", "startRegister"], this.email, this.password, userData,
          this.recaptchaKey).then(result => {
          logger.removePassword(this.password)
          this.state = "done"
        }).catch(error => {
          logger.removePassword(this.password)
          this.error = error
          this.state = "ready"
          this.recaptchaKey = null
          this.$refs.recaptcha.reset()

          if(error == 'notFound') {
            this.$refs.email.parentElement.setAttribute('class',
              this.$refs.email.parentElement.getAttribute('class')+' is-invalid')
            this.$refs.email.focus()
          }
          if(error == 'wrongPassword') {
            this.$refs.password.parentElement.setAttribute('class',
              this.$refs.password.parentElement.getAttribute('class')+' is-invalid')
            this.$refs.password.focus()
          }
        })
      },
      resend(e) {
        e.preventDefault()

        this.state = "working"
        api.request(["emailPassword", "resendRegisterKey", this.email], this.email).then(result => {
          this.state = "resent"
        }).catch(error => {
          this.error = error
          this.state = "ready"
          if (error == 'notFound') {
            this.$refs.email.parentElement.setAttribute('class',
              this.$refs.email.parentElement.getAttribute('class') + ' is-invalid')
            this.$refs.email.focus()
          }
        })
      }
    },
    updated () {
      componentHandler.upgradeAllRegistered()
    },
    mounted () {
      componentHandler.upgradeAllRegistered()
      window.lfvm = this
    }
  }
</script>

<style scoped>

  .register-form {
    display: flex;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: url(../../../static/images/voleadstools2.png);
    background-position: center;
    background-size: 280%;
  }

  .mdl-card__supporting-text {
    width: 100%;
    box-sizing: border-box;
  }

  .mdl-card {
    min-width: 340px;
    width: 680px;
    margin: auto;
  }
  .mdl-card__title {
    height: 110px;
    color: #fff;
    background: url(../../../static/images/voleadstools2_mid.png) calc(100% - 55px) 5px no-repeat #241d7f;
    background-size: 100px;
  }

  button {
    background: #1d0585;
    color: white;
    font-weight: 300;
    float: right;
  }

  button:hover {
    background: #2906bf;
    color: white;
    font-weight: 300;
  }

  .mdl-card__supporting-text {
    position: relative;
  }

  form.blurred {
    filter: blur(2px);
  }

  form > div {
    margin-right: 1em;
  }

  .working {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    text-align: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.3);
  }
  .working div {
    margin: auto;
    height: 5em;
    width: 5em;
  }

  .error {
    height: 3em;
    font-size: 1.23em;
    color: #d00000;
  }

  .phoneNumber {
    width: 300px;
    margin-right: 1em;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// RegisterForm.vue?3316a882